import React from "react"

export function useOnReachBottom(callback: () => void, enabled: boolean = true) {
  React.useEffect(() => {
    if (!enabled) return
    const handler = () => {
      if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
        callback()
      }
    }
    window.addEventListener("scroll", handler, { passive: true })
    return () => window.removeEventListener("scroll", handler)
  }, [enabled])

}
